import React from 'react';
import ReactDOM from 'react-dom';

import Text from '../Components/Text'


const text = document.getElementsByClassName('container_text')
for (var i = 0; i < text.length; i++) {
	const dataTitleText = JSON.parse(text[i].getAttribute('data-info'))
	ReactDOM.render(<Text {...dataTitleText} />,text[i])
}


// WEBPACK FOOTER //
// ./src/build/privacy.js